<div class="row">
  <h6 style="margin-bottom: 10px">
    <span style="color: #f49602">&#9679;</span>
    &nbsp; Please select a material to fill the geometry
  </h6>

  <div class="col-10">
    <usimweb-dropdown
      placeholder="Material"
      [default]="selectedMaterial"
      [values]="foams"
      [key]="key"
      [value]="valueFoam"
      (selectionChange)="blur()"
      (selectionChange)="selectionChangedMaterial($event)"
      [required]="true"
    ></usimweb-dropdown>
  </div>

  <div class="col-2">
    <usimweb-button-icon
      [icon]="'search'"
      fontColor="white"
      toolTip="Select CAD geometry from list..."
      (btnClick)="openMaterialDetailDialog()"
    ></usimweb-button-icon>
  </div>
</div>

<div *ngIf="!foams" style="display: inline-block; margin-left: 5px">
  <usimweb-loader style="margin-top: 10px" [size]="22" [enabled]="true"></usimweb-loader>
</div>

<!-- <div style="display: inline-block; width: 95%">
  <usimweb-dropdown
    *ngIf="showRecipe"
    placeholder="Recipe"
    [default]="selectedRecipe"
    [values]="recipes"
    [key]="key"
    [value]="valueRecipe"
    (selectionChange)="blur()"
    (selectionChange)="selectionChangedRecipe($any($event))"
    [required]="true"
  ></usimweb-dropdown>
</div>
<div style="display: inline-block; margin-left: 5px">
  <usimweb-loader style="margin-top: 10px" [size]="22" [enabled]="recipeLoading"></usimweb-loader>
</div> -->

<div style="display: inline-block; width: 95%">
  <usimweb-dropdown
    #tempMenu
    *ngIf="usimdata"
    placeholder="Simulation data"
    [value]="valueUsimData"
    [key]="key"
    [values]="usimdatas"
    (selectionChange)="blur()"
    (selectionChange)="selectionChangedUsimData($event)"
    [required]="true"
  ></usimweb-dropdown>
</div>

<!-- <div style="display: inline-block; margin-left: 5px">
  <usimweb-loader style="margin-top: 10px" [size]="22" [enabled]="temperatureLoading"></usimweb-loader>
</div> -->
